export default "__VITE_ASSET__cgl3jFgb__"